// ===============================================================
// 🎁 giftsCatalog.js
// المصدر الوحيد لجميع الهدايا داخل المتجر
// أي هدية جديدة تُضاف هنا فقط
// القاعدة المعتمدة:
// - أغلب الهدايا SVGA
// - يمكن لبعض الهدايا الفخمة أن تكون video
// - أي هدية ليس لها assetUrl فعلي تبقى disabled مؤقتًا
// - featured gifts يمكن تخصيص موضعها لكل هدية عبر offset + display + animation
// ===============================================================

export const GIFT_TABS = [
  { key: "small", labelKey: "gifts.tabs.small", label: "Small" },
  { key: "medium", labelKey: "gifts.tabs.medium", label: "Medium" },
  { key: "big", labelKey: "gifts.tabs.big", label: "Big" },
  { key: "luxury", labelKey: "gifts.tabs.luxury", label: "Luxury" },
];

export const GIFTS = [
  // ===========================================================
  // SMALL
  // ===========================================================
  {
    id: "cool_banana",
    name: "Cool Banana",
    icon: "🍌",
    price: 15,
    size: "small",
    tab: "small",
    assetType: "svga",
    assetUrl: "/gifts/cool_banana.svga",
    previewUrl: "/gifts/cool_banana_preview.png",
    enabled: true,
    offset: {
      sender: -42,
      receiver: -35,
    },
    display: {
      durationMs: 2600,
      width: "40vw",
      height: "auto",
      top: "50%",
      left: "50%",
      translateX: "-40%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "smallGiftPop",
  },
  {
    id: "teddy_bear",
    name: "Teddy Bear",
    icon: "🧸",
    price: 20,
    size: "small",
    tab: "small",
    assetType: "svga",
    assetUrl: "/gifts/teddy_bear.svga",
    previewUrl: "/gifts/teddy_bear_preview.png",
    enabled: true,
    offset: {
      sender: -40,
      receiver: -40,
    },
    display: {
      durationMs: 2800,
      width: "50vw",
      height: "auto",
      top: "55%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "smallGiftPop",
  },
  {
    id: "love_heart",
    name: "Love Heart",
    icon: "💖",
    price: 30,
    size: "small",
    tab: "small",
    assetType: "svga",
    assetUrl: "/gifts/love_heart.svga",
    previewUrl: "/gifts/love_heart_preview.png",
    enabled: true,
    offset: {
      sender: -35,
      receiver: -28,
    },
    display: {
      durationMs: 2800,
      width: "100vw",
      height: "auto",
      top: "54%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "smallGiftPop",
  },
  {
    id: "golden_tea",
    name: "Golden Tea",
    icon: "☕",
    price: 50,
    size: "small",
    tab: "small",
    assetType: "svga",
    assetUrl: "/gifts/golden_tea.svga",
    previewUrl: "/gifts/golden_tea_preview.png",
    enabled: true,
    offset: {
      sender: -42,
      receiver: -35,
    },
    display: {
      durationMs: 3000,
      width: "100vw",
      height: "auto",
      top: "55%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "smallGiftPop",
  },
  {
    id: "birthday_cake",
    name: "Birthday Cake",
    icon: "🎂",
    price: 85,
    size: "small",
    tab: "small",
    assetType: "svga",
    assetUrl: "/gifts/birthday_cake.svga",
    previewUrl: "/gifts/birthday_cake_preview.png",
    enabled: true,
    offset: {
      sender: -45,
      receiver: -35,
    },
    display: {
      durationMs: 3000,
      width: "60vw",
      height: "auto",
      top: "55%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "smallGiftPop",
  },
  {
    id: "love_ride",
    name: "Love Ride",
    icon: "💗",
    price: 100,
    size: "small",
    tab: "small",
    assetType: "svga",
    assetUrl: "/gifts/love_ride.svga",
    previewUrl: "/gifts/love_ride_preview.png",
    enabled: true,
    offset: {
      sender: -45,
      receiver: -45,
    },
    display: {
      durationMs: 100,
      width: "-50vw",
      height: "auto",
      top: "20%",
      left: "20%",
      translateX: "-20%",
      translateY: "-20%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "smallGiftPop",
  },

  // ===========================================================
  // MEDIUM
  // ===========================================================
  {
    id: "sweet_kiss",
    name: "Sweet Kiss",
    icon: "💋",
    price: 200,
    size: "medium",
    tab: "medium",
    assetType: "svga",
    assetUrl: "/gifts/sweet_kiss.svga",
    previewUrl: "/gifts/sweet_kiss_preview.png",
    enabled: true,
    offset: {
      sender: -40,
      receiver: -30,
    },
    display: {
      durationMs: 2000,
      width: "50vw",
      height: "auto",
      top: "52%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "kissPop",
  },
  {
    id: "love_airship",
    name: "Love Airship",
    icon: "💖",
    price: 250,
    size: "medium",
    tab: "medium",
    assetType: "svga",
    assetUrl: "/gifts/love_airship.svga",
    previewUrl: "/gifts/love_airship_preview.png",
    enabled: true,
    offset: {
      sender: -40,
      receiver: -26,
    },
    display: {
      durationMs: 4800,
      width: "120vw",
      height: "auto",
      top: "42%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "loveAirshipFloat",
  },
  {
    id: "bunny_cannon",
    name: "Bunny Love Cannon",
    icon: "🐰",
    price: 300,
    size: "medium",
    tab: "medium",
    assetType: "svga",
    assetUrl: "/gifts/bunny_cannon.svga",
    previewUrl: "/gifts/bunny_cannon_preview.png",
    enabled: true,
    offset: {
      sender: -45,
      receiver: -37,
    },
    display: {
      durationMs: 1500,
      width: "100vw",
      height: "auto",
      top: "0%",
      left: "50%",
      translateX: "0%",
      translateY: "0%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "cannonBlast",
  },
  {
    id: "diamond_ring",
    name: "Diamond Ring",
    icon: "💍",
    price: 500,
    size: "medium",
    tab: "medium",
    assetType: "svga",
    assetUrl: "/gifts/diamond_ring.svga",
    previewUrl: "/gifts/diamond_ring_preview.png",
    enabled: true,
    offset: {
      sender: -44,
      receiver: -44,
    },
    display: {
      durationMs: 4600,
      width: "82vw",
      height: "auto",
      top: "48%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "diamondRingPop",
  },

  // ===========================================================
  // BIG
  // ===========================================================
  {
    id: "rose_elixir",
    name: "Rose Elixir",
    icon: "🍷",
    price: 2000,
    size: "big",
    tab: "big",
    assetType: "svga",
    assetUrl: "/gifts/rose_elixir_fixed_same_as_red_heart.svga",
    previewUrl: "/gifts/rose_elixir_preview.png",
    enabled: true,
    offset: {
      sender: -35,
      receiver: -45,
    },
     display: {
      durationMs: 300,
      width: "80vw",
      height: "auto",
      top: "48%",
      left: "50%",
      translateX: "-50%",
      translateY: "-50%",
      zIndex: 99999,
      objectFit: "contain",
    },
    animation: "diamondRingPop",
  
  },
  {
    id: "celebration_shot",
    name: "Celebration Shot",
    icon: "🎆",
    price: 1000,
    size: "big",
    tab: "big",
    assetType: "svga",
    assetUrl: "/gifts/celebration_shot.svga",
    previewUrl: "/gifts/celebration_shot_preview.png",
    enabled: true,
    offset: {
      sender: -49,
      receiver: -30,
    },
  },
  {
    id: "eternal_bond",
    name: "Eternal Bond",
    icon: "💍",
    price: 1500,
    size: "big",
    tab: "big",
    assetType: "svga",
    assetUrl: "/gifts/eternal_bond.svga",
    previewUrl: "/gifts/eternal_bond_preview.png",
    enabled: true,
    offset: {
      sender: -50,
      receiver: -46,
    },
  },
  {
    id: "enchanted_rose_heart",
    name: "Enchanted Rose Heart",
    icon: "🌹",
    price: 2500,
    size: "big",
    tab: "big",
    assetType: "svga",
    assetUrl: "/gifts/enchanted_rose_heart.svga",
     soundUrl: "/gifts/rose_elixir_enhanced_audio.mp3",
    previewUrl: "/gifts/enchanted_rose_heart_preview.png",
    enabled: true,
    offset: {
      sender: -39,
      receiver: -25,
    },
  },
  {
    id: "royal_wedding",
    name: "Royal Wedding",
    icon: "💍",
    price: 3000,
    size: "big",
    tab: "big",
    assetType: "svga",
    assetUrl: "/gifts/royal_wedding.svga",
    previewUrl: "/gifts/royal_wedding_preview.png",
    enabled: true,
    offset: {
      sender: -40,
      receiver: -25,
    },
  },

  // ===========================================================
  // LUXURY
  // ===========================================================
  {
    id: "lion",
    name: "Royal Lion",
    icon: "🦁",
    price: 10000,
    size: "luxury",
    tab: "luxury",
    assetType: "svga",
    assetUrl: "/gifts/lion_royal.svga",
    soundUrl: "/gifts/royal_wedding1_audio.m4a",
    previewUrl: "/gifts/lion_preview.png",
    enabled: true,
    offset: {
      sender: -40,
      receiver: -40,
    },
  },
{
  id: "royal_wedding_video",
  name: "Royal Wedding",
  icon: "🦁",
    price: 9000,
  size: "luxury",
  tab: "luxury",
  assetType: "video",
assetUrl: "/gifts/royal_wedding1_fixed.mp4",
soundUrl: "/gifts/royal_wedding1_audio.m4a",
  previewUrl: "/gifts/royal_wedding1_preview.png",
  enabled: true,
  offset: {
    sender: 0,
    receiver: 0,
  },
  display: {
    durationMs: 8000,
    width: "100vw",
    height: "100vh",
    top: "0%",
    left: "0%",
    translateX: "0%",
    translateY: "0%",
    zIndex: 999999,
    objectFit: "cover",
  },
  animation: "videoFullScreen",
},
  {
    id: "dragon",
    name: "Fire Dragon",
    icon: "🐉",
    price: 9000,
    size: "luxury",
    tab: "luxury",
    assetType: "svga",
    assetUrl: "/gifts/dragon_fire.svga",
    previewUrl: "/gifts/dragon_preview.png",
    enabled: true,
    offset: {
      sender: -47,
      receiver: -37,
    },
  },
  {
    id: "royal_castle",
    name: "Royal Castle",
    icon: "🏰",
    price: 8000,
    size: "luxury",
    tab: "luxury",
    assetType: "svga",
    assetUrl: "/gifts/royal_castle.svga",
    previewUrl: "/gifts/castle_preview.png",
    enabled: true,
    offset: {
      sender: -40,
      receiver: -30,
    },
  },
  {
    id: "yacht",
    name: "Yacht",
    icon: "🛥️",
    price: 7000,
    size: "luxury",
    tab: "luxury",
    assetType: "svga",
    assetUrl: "/gifts/yacht.svga",
    previewUrl: "/gifts/yacht_preview.png",
    enabled: true,
    offset: {
      sender: -46,
      receiver: -42,
    },
  },
];

export function getEnabledGiftsByTab(tabKey) {
  return GIFTS.filter((gift) => gift.enabled === true && gift.tab === tabKey);
}

export function getGiftById(giftId) {
  return GIFTS.find((gift) => gift.id === giftId) || null;
}

// ===============================================================
// بما أنك تريد الهدايا الصغيرة تظهر مثل الكبيرة:
// نجعل small أيضًا تمر على featured stage
// ===============================================================
export function isLargeGiftSize(size) {
  const safeSize = String(size || "").toLowerCase();
  return (
    safeSize === "small" ||
    safeSize === "medium" ||
    safeSize === "big" ||
    safeSize === "large" ||
    safeSize === "luxury"
  );
}